exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-377538dc] .v-application--wrap{min-height:-moz-fit-content;min-height:fit-content}button[data-v-377538dc]:focus{outline:0}.btn-info[data-v-377538dc]{border-radius:5px 0 0 5px}.info-data[data-v-377538dc]{border:2px solid #fb7e42;border-radius:5px;font-size:1.25rem;font-weight:700}.info-data[data-v-377538dc],.info-label[data-v-377538dc]{color:#fb7e42}", ""]);

// exports
